import { Injectable } from '@angular/core';
import { MpsTemplatesDataService } from '@mps/mps-kit/shared/services/mps-templates-data.service';
import { hpc_button_templates } from './hpc-button.templates';
import { hpc_grid_templates } from './hpc-grid.templates';
import { hpc_panel_templates } from './hpc-panel.templates';
import { hpc_sidebar_factory_templates } from './hpc-sidebar.templates';
import { hpc_table_factory_templates, hpc_table_templates } from './hpc-table.templates';

@Injectable({
  providedIn: 'root',
})
export class HpcTemplatesDataService extends MpsTemplatesDataService {
  override getButtonTemplates() {
    return hpc_button_templates;
  }

  override getPanelTemplates() {
    return hpc_panel_templates;
  }

  override getGridTemplates() {
    return hpc_grid_templates;
  }

  override getTableTemplates() {
    return hpc_table_templates;
  }

  override getTableFactoryTemplates() {
    return hpc_table_factory_templates;
  }

  override getSidebarFactoryTemplates() {
    return hpc_sidebar_factory_templates;
  }
}
